import type { FormInstance, UploadProps } from 'antd';
import { Upload, message } from 'antd';
import { JsonFormDataArgs } from '../constants/constants';

type UploadWrapperProps = {
  form: FormInstance;
  children?: React.ReactNode;
  setCurrentStep: (step: number) => void;
  onValuesChange: (changedValues: any, form: FormInstance) => void;
};

export const UploadWrapper = ({
  form,
  children,
  setCurrentStep,
  onValuesChange,
}: UploadWrapperProps) => {
  const props: UploadProps = {
    name: 'file',
    multiple: false,
    accept: '.json',
    beforeUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const readFormData: JsonFormDataArgs = JSON.parse(
            e.target?.result as string,
          );
          form.resetFields();
          form.setFieldsValue(readFormData.formData);
          setCurrentStep(0);
          setTimeout(() => onValuesChange(readFormData.formData, form), 1000);

          message.success(
            `Formos duomenys iš dokumento ${file.name} nuskaityti sėkmingai.`,
          );
        } catch (error) {
          message.error(
            `Formos duomenų iš dokumento ${file.name} nuskaityti nepavyko.`,
          );
        }
      };
      reader.readAsText(file);

      return false;
    },
    maxCount: 1,
  };

  return (
    <Upload
      style={{
        textAlign: 'inherit',
      }}
      {...props}
    >
      {children}
    </Upload>
  );
};
